import React from 'react'
import StoreForm from '../../components/Stores/StoreForm'


export const CreateStore = () => {
  return <StoreForm mode="Create"/>
}
